/**
 * Descarta dos query params o que o back lê como **filtro ausente**, espelhando
 * `app/routes/shared/list_params.py` do lado de cá.
 *
 * O back trata `?x=` (chave presente, valor vazio) como se o param não tivesse
 * sido enviado — mas depender disso é frágil: `?from_ts=` só não dá 422 porque
 * o back limpa antes de coagir, e uma seleção vazia mandada como `?kind=` gasta
 * request e polui a URL. Melhor não emitir.
 *
 * O que NÃO é ausência: `false` e `0`. `legacy=false` é uma escolha tri-state
 * (casa também documento sem a chave, `$ne: true`), não "sem filtro"; e
 * `from_ts=0` é uma data. Por isso o teste é explícito por valor, nunca falsy.
 */
export function limpaParams<T extends Record<string, unknown>>(params: T): Partial<T> {
  const limpos: Record<string, unknown> = {}
  for (const [chave, valor] of Object.entries(params)) {
    if (valor === undefined || valor === null || valor === '') continue
    // Seleção vazia é "sem filtro", nunca `$in: []` (que casaria zero docs).
    if (Array.isArray(valor) && valor.length === 0) continue
    limpos[chave] = valor
  }
  return limpos as Partial<T>
}
